export class InvCyclicAuditorEntity{
    id:number;
    cyclicId:number;
    personId:number;
    person:string;
    active:boolean;

    constructor(){}
}